import React, { useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { useSelector } from 'react-redux';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';

const YouTubeEmbed = () => (
  <>
    <FlexContainer className={'width100 m-hide'}>
      <iframe
        width="60%"
        height="315"
        src="https://www.youtube.com/embed/x-3jXqI1jS4"
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </FlexContainer>
    <FlexContainer className={'width100 d-hide'}>
      <iframe
        width="100%"
        height="315"
        src="https://www.youtube.com/embed/x-3jXqI1jS4"
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </FlexContainer>
  </>
);

const NewBlogCardDetailVersion = ({ blogDetail, setShowDetail }) => {
  const languageData = useSelector(state => state.lenguage?.lang);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const postImage =
    blogDetail?.post_img != null
      ? JSON.parse(blogDetail.post_img)[0]
      : 'default-image.jpg';
  const formattedDate = new Date(blogDetail?.post_date).toLocaleDateString(
    languageData === 'EN' ? 'en-US' : 'es-PE',
    { year: 'numeric', month: 'long', day: 'numeric' },
  );

  return (
    <FlexContainer className={'flex-column width100 blogView'}>
      <HelmetComponent
        title={languageData === 'EN' ? 'Blog - Popnest' : 'Blog - Popnest'}
        description={
          languageData === 'EN'
            ? 'Explore articles about Popnest in English'
            : 'Explora artículos sobre Popnest en Español'
        }
        graphTitle={languageData === 'EN' ? 'Blog - Popnest' : 'Blog - Popnest'}
        graphDescription={
          languageData === 'EN'
            ? 'Explore articles about Popnest in English'
            : 'Explora artículos sobre Popnest en Español'
        }
      />

      <FlexContainer className={'flex-column banner width100 items-align-left'}>
        <FlexContainer className={'info-box flex-column align-items-center'}>
          <Label className="text-40 m-text-28 padlr100 m-padlr20">
            <strong>
              {languageData === 'EN'
                ? blogDetail?.post_title_en
                : blogDetail?.post_title}
            </strong>
          </Label>
        </FlexContainer>
        <img
          src={postImage}
          alt="Detalle de foto de entrada"
          style={{ width: '100%', height: '500px' }}
          className={''}
        />
      </FlexContainer>

      <FlexContainer className={'m-flex-column margt40 padlr100 m-padlr10'}>
        <FlexContainer
          className={'flex-column format40 align-items-end m-hide'}
        >
          <button
            type="button"
            className={
              'bgWhite border-rad4px padlr20 padtb6 fontGray500 text-16 margt10 margr20'
            }
            onClick={() => window.history.back()}
          >
            {languageData === 'EN' ? 'Back' : 'Atrás'}
          </button>
        </FlexContainer>

        <FlexContainer className={'flex-column width100 gap-20 d-hide'}>
          <button
            type="button"
            className={
              'bgWhite border-rad4px padlr20 padtb6 fontGray500 text-16 margt10'
            }
            onClick={() => window.history.back()}
          >
            {languageData === 'EN' ? 'Back' : 'Atrás'}
          </button>
          <Label className="text-12 margt10 marglr10 align-items-end">
            {formattedDate} -
          </Label>
        </FlexContainer>

        <FlexContainer className={'flex-column format100'}>
          <Label className="text-26 m-text-18 margb10 margt10">
            <strong>
              {languageData === 'EN'
                ? blogDetail?.post_title_en
                : blogDetail?.post_title}
            </strong>
          </Label>

          <Label className="text-16 m-hide">{formattedDate}</Label>
          <Label
            className="text-18 m-text-14 margb10 margt30"
            dangerouslySetInnerHTML={{
              __html:
                languageData === 'EN'
                  ? blogDetail?.post_detail_en
                  : blogDetail?.post_detail,
            }}
          />

          <Label className="text-20 m-text-16 margb60 margt20">
            <YouTubeEmbed />
          </Label>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default NewBlogCardDetailVersion;
